var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticClass:"learn-content"},[_c('h1',{staticClass:"blue--text"},[_vm._v("Homepage")]),_c('v-btn',{staticClass:"pink",attrs:{"depressed":"","flat":""}},[_vm._v("Login")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }